import { COUNTRY_ENUM, PLATFORM_ENUM } from 'services/api/constants'
import { CampaignState, REQUIREMENT_TYPE_ENUM, CAMPAIGN_STATUS_ENUM } from 'state/campaigns'
import { TASK_TYPE_ENUM, STEP_TYPE_ENUM } from 'services/api/constants'
import { TFunction } from 'i18next'
import { round } from 'lodash'
import { showSnackBar } from 'services/toast'

export const checkRequirement = (campaign: CampaignState, platform: PLATFORM_ENUM) => {
    const isPlatformRequired = campaign.requirements.map(requirement => {
        const { type, properties } = requirement
        if (!type || !properties || type !== REQUIREMENT_TYPE_ENUM.FOLLOWER) {
            return false
        } else {
            const isRequired =
                properties.followers && properties.followers.find(follower => follower.platform === platform)
            if (isRequired) {
                return true
            } else {
                return false
            }
        }
    })
    return isPlatformRequired[0]
}

type LinkInBioPostStepType =
    | STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_POST_URL
    | STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_TIKTOK_POST_URL
    | STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_REEL_URL
    | STEP_TYPE_ENUM.POST_TO_IG_STORY
    | STEP_TYPE_ENUM.POST_TO_IG_POST

export const hasLinkInBioStepType = (stepType: STEP_TYPE_ENUM): stepType is LinkInBioPostStepType => {
    return (
        stepType === STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_POST_URL ||
        stepType === STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_TIKTOK_POST_URL ||
        stepType === STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_REEL_URL ||
        stepType === STEP_TYPE_ENUM.POST_TO_IG_STORY ||
        stepType === STEP_TYPE_ENUM.POST_TO_IG_POST
    )
}

export const getLinkInBioPostStepType = (taskType: TASK_TYPE_ENUM): string | undefined => {
    return taskType === TASK_TYPE_ENUM.IG_POST_V02
        ? STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_POST_URL
        : taskType === TASK_TYPE_ENUM.TIKTOK_POST
          ? STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_TIKTOK_POST_URL
          : taskType === TASK_TYPE_ENUM.IG_REEL
            ? STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_REEL_URL
            : taskType === TASK_TYPE_ENUM.IG_STORY || taskType === TASK_TYPE_ENUM.IG_STORY_V02
              ? STEP_TYPE_ENUM.POST_TO_IG_STORY
              : taskType === TASK_TYPE_ENUM.IG_POST
                ? STEP_TYPE_ENUM.POST_TO_IG_POST
                : undefined
}

//--------------- temp validation error flatten function ------------//

export const flattenObject = (source: any, keyArray?: string[], result?: any): any => {
    keyArray = typeof keyArray === 'undefined' ? [] : keyArray
    result = typeof result === 'undefined' ? {} : result
    let key, value, newKey
    for (const i in source) {
        if (source.hasOwnProperty(i)) {
            key = i
            value = source[i]
            keyArray.push(key)
            if (typeof value === 'object' && value !== null) {
                result = flattenObject(value, keyArray, result)
            } else {
                newKey = keyArray.join('_')
                result[newKey] = value
            }
            keyArray.pop()
        }
    }
    return result
}
export const extractErrorCode = (source: any) => {
    if (source == null || Array.isArray(source)) {
        if (source[0] && source[0]['code']) return source[0]['code']
    }
    const output: any = {}
    for (const key of Object.keys(source)) {
        output[key] = extractErrorCode(source[key])
    }
    return output
}

export const isShowCardReviewComponent = (stepType: STEP_TYPE_ENUM): boolean => {
    return (
        // FB post step using MUI loading
        stepType !== STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_FACEBOOK_POST_URL &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_PROOF_FB_URL &&
        // IG story step using MUI loading
        stepType !== STEP_TYPE_ENUM.SUBMIT_PROOF_IG_SCREENSHOT &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_IG_SCREENSHOT &&
        stepType !== STEP_TYPE_ENUM.POST_TO_IG_STORY &&
        // IG post step using MUI loading
        stepType !== STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_POST_URL &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_PROOF_IG_URL &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_IG_POST &&
        // Tiktok post step using MUI loading
        stepType !== STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_TIKTOK_POST_URL &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_TIKTOK_POST &&
        // IG reel step using MUI loading
        stepType !== STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_INSTAGRAM_REEL_URL &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_INSTAGRAM_REEL &&
        // XHS step using MUI loading
        stepType !== STEP_TYPE_ENUM.POST_AND_SUBMIT_PROOF_XIAOHONGSHU_POST_URL &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_XIAOHONGSHU_POST &&
        // Engagement Step for FB Post, IG Reel, Twitter Post, Youtube Video Post, Others
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_FACEBOOK_POST &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_TWITTER_POST &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_YOUTUBE_VIDEO &&
        stepType !== STEP_TYPE_ENUM.SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_OTHERS &&
        // Non Submission: Purchase Product, Attend Event
        stepType !== STEP_TYPE_ENUM.PURCHASE_PRODUCT &&
        stepType !== STEP_TYPE_ENUM.ATTEND_EVENT
    )
}

const localeMap: Record<COUNTRY_ENUM, { localeCode: string; currencyCode: string }> = {
    [COUNTRY_ENUM.ID]: {
        currencyCode: 'IDR',
        localeCode: 'id-ID',
    },
    [COUNTRY_ENUM.SG]: {
        currencyCode: 'SGD',
        localeCode: 'en-SG',
    },
    [COUNTRY_ENUM.MY]: {
        currencyCode: 'MYR',
        localeCode: 'ms-MY',
    },
    [COUNTRY_ENUM.HK]: {
        currencyCode: 'HKD',
        localeCode: 'zh-HK',
    },
    [COUNTRY_ENUM.PH]: {
        currencyCode: 'PHP',
        localeCode: 'fil-PH',
    },
    [COUNTRY_ENUM.TH]: {
        currencyCode: 'THB',
        localeCode: 'th-TH',
    },
    [COUNTRY_ENUM.VN]: {
        currencyCode: 'VND',
        localeCode: 'vi-VN',
    },
    [COUNTRY_ENUM.TW]: {
        currencyCode: 'TWD',
        localeCode: 'zh-TW',
    },
}

// returning formatted number based on country
// with country specific: thousand separator, and decimal
export const formatLocaleNumber = (country: COUNTRY_ENUM, value: number) => {
    const { currencyCode, localeCode } = localeMap[country] || {}

    if (!currencyCode || !localeCode) return ''

    return new Intl.NumberFormat(localeCode).format(value)
}

// get decimal separator by country. by getting substring of the formatted number
export const getDecimalSeparatorByCountry = (country: COUNTRY_ENUM) =>
    (1.1).toLocaleString(localeMap[country].localeCode).substring(1, 2)

export {
    runValidateSchema,
    validateStringOrNumberArrayField,
    checkErrorExist,
    validateFieldsAreAllPassed,
    setInitialTouched,
} from './errors'

export const reorderList = <T = any>(
    list: Iterable<T> | ArrayLike<T>,
    fromIndex: number,
    toIndex: number,
): Array<T> => {
    const result = Array.from(list)
    const [removed] = result.splice(fromIndex, 1)
    result.splice(toIndex, 0, removed)

    return result
}

export function isSupportAddPostTimeStepType(stepType: STEP_TYPE_ENUM) {
    // Every step 1 in task that can schedule post (can see campaign.task_types.config.can_schedule_post = true in common data api response)
    return [
        STEP_TYPE_ENUM.SUBMIT_CONTENT_FB_POST,
        STEP_TYPE_ENUM.SUBMIT_CONTENT_IG_POST,
        STEP_TYPE_ENUM.SUBMIT_CONTENT_IG_STORY,
        STEP_TYPE_ENUM.SUBMIT_CONTENT_TIKTOK_POST,
        STEP_TYPE_ENUM.SUBMIT_CONTENT_IG_REEL,
        STEP_TYPE_ENUM.SUBMIT_CONTENT_XIAOHONGSHU_POST,
    ].includes(stepType)
}

export const engagementDataFields = [
    'insights_screenshot_files',
    'view_count_screenshot_files',
    'follower_count',
    'engagement_impression_count',
    'engagement_like_count',
    'engagement_reach_count',
    'engagement_view_count',
    'engagement_comment_count',
    'engagement_tag_count',
    'engagement_share_count',
    // IG Story Only
    'engagement_sticker_tap_count',
    // Tiktok only
    'engagement_cta_click_count',
    'engagement_save_count',
    'engagement_total_play_time_second_count',
    'engagement_watched_full_video_percentage_count',
    // Twitter Only
    'engagement_reply_count',
    'engagement_retweet_count',
    'engagement_engagement_count',
    // IG Reels only
    'engagement_total_watch_time_second_count',
    // Tiktok and IG reels only
    'engagement_average_watch_time_second_count',
]

export { getStringLength } from './stringCheck'
export const checkInType = (input: string, typeUnion: string[]): boolean => {
    return typeUnion.some((union: string) => input.includes(union))
}

export {
    isSortable,
    isAToZField,
    isHighestToLowestField,
    getSortQueryText,
    isLatestToOldestField,
    isOppositeSortField,
    isYesToNoField,
} from './filterAndSort'

export { validateDateLaterThenNow } from './validation'

export { getDayLeftDisplay } from './timelineDisplay'

export { getStepTypeAvailabiltyStatus } from './submission'
export type { SubmissionStatusAvailability } from './submission'

export const snakeCaseToCamelCase = (input: string): string => {
    return input.replace(/_([a-z])/g, (_, match) => match.toUpperCase())
}
export const camelCaseToSnakeCase = (input: string): string => {
    return input.replace(/[A-Z]/g, match => `_${match.toLowerCase()}`)
}

export const snakecaseToTitleCase = (input: string): string => {
    return input.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
}

export const getCampaignStatusColor = (campaignStatus: CAMPAIGN_STATUS_ENUM, isStatusText = false) => {
    switch (campaignStatus) {
        case CAMPAIGN_STATUS_ENUM.DRAFT: {
            return 'explosiveGrey'
        }
        case CAMPAIGN_STATUS_ENUM.FOR_REVIEW: {
            return 'darkOrange'
        }
        case CAMPAIGN_STATUS_ENUM.LIVE: {
            return 'doneGreen'
        }
        case CAMPAIGN_STATUS_ENUM.CLOSED: {
            return isStatusText ? 'explosiveGrey' : 'lightGrey'
        }
        case CAMPAIGN_STATUS_ENUM.ENDED: {
            return isStatusText ? 'ribbonRed' : 'ribbonRed'
        }
        case CAMPAIGN_STATUS_ENUM.FOR_EDIT: {
            return 'yolkYellow'
        }
        case CAMPAIGN_STATUS_ENUM.WAIT_FOR_PAYMENT: {
            return 'irisPurple'
        }
        case CAMPAIGN_STATUS_ENUM.READY_FOR_LAUNCH: {
            return 'darkGreen'
        }
        case CAMPAIGN_STATUS_ENUM.ENDED: {
            return 'ribbonRed'
        }
        case CAMPAIGN_STATUS_ENUM.EXPIRED: {
            return 'black'
        }
        case CAMPAIGN_STATUS_ENUM.FULFILLED: {
            return 'skyBlue'
        }
        case CAMPAIGN_STATUS_ENUM.PAID_OUT: {
            return isStatusText ? 'explosiveGrey' : 'lightGrey'
        }
        case CAMPAIGN_STATUS_ENUM.PAUSED: {
            return isStatusText ? 'explosiveGrey' : 'lightGrey'
        }
        default:
            return 'explosiveGrey'
    }
}

export const getCampaignStatusTitle = (campaignStatus: CAMPAIGN_STATUS_ENUM, t: TFunction) => {
    switch (campaignStatus) {
        case CAMPAIGN_STATUS_ENUM.DRAFT: {
            return t('statusLabel.draft')
        }
        case CAMPAIGN_STATUS_ENUM.FOR_REVIEW: {
            return t('statusLabel.forReviewAllCapital')
        }
        case CAMPAIGN_STATUS_ENUM.LIVE: {
            return t('statusLabel.live')
        }
        case CAMPAIGN_STATUS_ENUM.CLOSED: {
            return t('statusLabel.closed')
        }
        case CAMPAIGN_STATUS_ENUM.ENDED: {
            return t('statusLabel.card.ended')
        }
        case CAMPAIGN_STATUS_ENUM.FOR_EDIT: {
            return t('statusLabel.forEdit')
        }
        case CAMPAIGN_STATUS_ENUM.WAIT_FOR_PAYMENT: {
            return t('statusLabel.waitingForPayment')
        }
        case CAMPAIGN_STATUS_ENUM.READY_FOR_LAUNCH: {
            return t('statusLabel.waitingForLaunch')
        }
        case CAMPAIGN_STATUS_ENUM.ENDED: {
            return t('statusLabel.card.ended')
        }
        case CAMPAIGN_STATUS_ENUM.EXPIRED: {
            return t('statusLabel.expired')
        }
        case CAMPAIGN_STATUS_ENUM.FULFILLED: {
            return t('statusLabel.fulfilled')
        }
        case CAMPAIGN_STATUS_ENUM.PAID_OUT: {
            return t('statusLabel.paidOut')
        }
        case CAMPAIGN_STATUS_ENUM.PAUSED: {
            return t('PAUSED')
        }
        default:
            return ''
    }
}

export const formatCurrencyNumberInput = ({
    value,
    currencySign,
    country,
    decimal,
}: {
    value: string | number
    currencySign?: string | null
    country?: COUNTRY_ENUM | null
    decimal?: boolean
}) => {
    const valueNum = +value
    const currencyPrefix = currencySign ? `${currencySign} ` : ''
    // exit if not number
    if (Number.isNaN(valueNum)) {
        return
    }

    // exit if country not provided
    if (!country) {
        return value?.toString()
    }

    // exit if not decimal from props
    if (!decimal) {
        return currencyPrefix + formatLocaleNumber(country, valueNum)
    }

    // round to 2 decimal, toFixed convert to string and supporting `.00` decimal
    const [integerPart, decimalPart] = round(valueNum, 2).toFixed(2).split('.')
    // format integer part to have thousand separator base on country
    const withThousandSeparator = formatLocaleNumber(country, +integerPart)

    // get decimal separator base on country
    const decimalSeparator = getDecimalSeparatorByCountry(country)
    // combine: thousand separated integer, decimal separator, and decimal number
    const fullFormattedNumber = withThousandSeparator + decimalSeparator + decimalPart

    return currencyPrefix + fullFormattedNumber
}

export const abbreviateNumber = (num: number): string => {
    if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`
    if (num >= 10_000) return `${(num / 1_000).toFixed(1).replace(/\.0$/, '')}k`
    return num.toLocaleString()
}

export const convertToThousandSeparator = (num?: number | null): string => {
    if (!num) return ''

    return new Intl.NumberFormat().format(num)
}

export const roundNumber = (value: number) => {
    const rounded = Math.round(value * 100) / 100 // round to 2 decimal places
    return parseFloat(rounded.toString()) // remove trailing zeroes like .00 or .50
}

export const removeEmptyOrNull = <T extends Record<string, unknown>>(obj: T): T => {
    Object.keys(obj).forEach(
        k =>
            (obj[k] && typeof obj[k] === 'object' && removeEmptyOrNull(obj[k] as Record<string, unknown>)) ||
            (!obj[k] && obj[k] !== undefined && delete obj[k]),
    )

    return obj
}

export const convertSecondsToTime = (totalSeconds: number | null): string => {
    if (totalSeconds === null || totalSeconds === undefined) return ''

    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    return `${hours}h:${minutes}m:${seconds}s`
}

export const convertTimeStringToSeconds = (timeString: string): number | null => {
    if (!timeString) return null

    // Strict format validation: must match pattern like "3h:1m:5s", "3h:1m", "3h", "1m:5s", "1m", "5s"
    const formatRegex = /^(\d+h)?:?(\d+m)?:?(\d+s)?$/
    if (!formatRegex.test(timeString)) {
        return null
    }

    const match = timeString.match(formatRegex)
    if (!match) return null

    const [, h, m, s] = match
    const hours = h ? parseInt(h, 10) : 0
    const minutes = m ? parseInt(m, 10) : 0
    const seconds = s ? parseInt(s, 10) : 0

    return hours * 3600 + minutes * 60 + seconds
}

export const copyToClipboard = (text: string, t: TFunction) => {
    if (!text) return
    navigator.clipboard.writeText(text).then(() => {
        showSnackBar({
            title: t('general.info.textCopied'),
            type: 'positive',
        })
    })
}

export const currentYear = new Date().getFullYear()

export const LIVE_CAMPAIGN_STATUSES: CAMPAIGN_STATUS_ENUM[] = [
    CAMPAIGN_STATUS_ENUM.LIVE,
    CAMPAIGN_STATUS_ENUM.EXPIRED,
    CAMPAIGN_STATUS_ENUM.FULFILLED,
    CAMPAIGN_STATUS_ENUM.PAID_OUT,
]

export const isCampaignLiveStatus = (status?: CAMPAIGN_STATUS_ENUM): boolean =>
    !!status && LIVE_CAMPAIGN_STATUSES.includes(status)
